import React from 'react';
import { Link } from 'react-router-dom';
import { productPath, purchasePath, macAppProducts } from '../seo/site';
import './BundleStrip.css';

const BundleStrip = ({
  bundle,
  products = [],
  otherProducts = [],
  sectionId = 'bundle',
  variant = 'top',
}) => {
  if (!bundle?.appStoreUrl) {
    return null;
  }

  const variantClass = {
    top: 'bundle-section--top',
    bottom: 'bundle-section--bottom',
    page: 'bundle-section--page',
  }[variant] || 'bundle-section--top';

  const sectionClassName = ['bundle-section', variantClass].join(' ');
  const isPageVariant = variant === 'page';
  const showMoreLinks = isPageVariant && otherProducts.length > 0;

  const bundleProducts = macAppProducts(products);

  return (
    <section
      id={sectionId || undefined}
      className={sectionClassName}
      aria-label={bundle.title}
    >
      <div className="section-content">
        <div className={`bundle-card${isPageVariant ? ' bundle-card--page' : ''}`}>
          {showMoreLinks && (
            <>
              <nav className="bundle-card-more" aria-label="More Freedman Labs apps">
                <span className="bundle-card-more-label">MORE FROM FREEDMAN LABS:</span>
                <div className="bundle-card-more-links">
                  {otherProducts.map((item, index) => (
                    <React.Fragment key={item.id}>
                      {index > 0 && (
                        <span className="bundle-card-more-divider" aria-hidden="true" />
                      )}
                      <Link
                        to={productPath(item.id)}
                        className="bundle-card-more-link"
                        style={{ '--accent': item.accentColor }}
                      >
                        {item.title}
                      </Link>
                    </React.Fragment>
                  ))}
                </div>
              </nav>
              <div className="bundle-card-separator" aria-hidden="true" />
            </>
          )}

          <div className="bundle-card-content">
            <div className="bundle-card-main">
              <div className="bundle-card-icons" aria-hidden="true">
                {bundleProducts.map((product) => (
                  <img
                    key={product.id}
                    src={product.app.image}
                    alt=""
                    className="bundle-card-icon"
                    width={52}
                    height={52}
                    loading="lazy"
                    decoding="async"
                  />
                ))}
              </div>

              <div className="bundle-card-text">
                <h2 className="bundle-card-title">{bundle.title}</h2>
                <p className="bundle-card-description">{bundle.description}</p>
              </div>
            </div>

            <div className="bundle-card-badges">
              <a
                href={bundle.appStoreUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="app-store-badge-link"
              >
                <img
                  src="/images/mac-app-store-badge.svg"
                  alt="Download on the Mac App Store"
                  className="app-store-badge"
                  height={40}
                  decoding="async"
                />
              </a>
              {bundle.directDownload?.enabled && bundle.id && (
                <a
                  href={purchasePath(bundle.id)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="direct-download-badge-link"
                  aria-label={`Direct download ${bundle.title}`}
                >
                  <img
                    src={bundle.directDownload.badgeImage || '/images/direct-download-badge.svg'}
                    alt="Direct Download"
                    className="direct-download-badge"
                    height={40}
                    decoding="async"
                  />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BundleStrip;
